import curry from './curry';
import pipe from './pipe';
import pipeAll from './pipeAll';

export default {
  curry,
  pipe,
  pipeAll,
};



// WEBPACK FOOTER //
// ./app/utils/functionalHelpers/index.js